"use strict";

/* global dataLayer */

import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import Toolbox from "./toolbox";


const ListingAnalyticsHelper = (function () {

	let _state = {};
	let _config = {};

	/**
	* Handles analytics.
	*/
	const AnalyticsHelper = {

		copyState: (state, config) => {
			_state = state || ItemListingState;
			_config = config || ItemListingConfig;
		},

		init: (state, config) => {
			AnalyticsHelper.copyState(state, config);

			if (_config.useCampaignAnalytics) {
				AnalyticsHelper.addSlotClickAnalytics();
			}

		},
		pushAnalyticsEvent: (event) => {
			if (dataLayer) {
				dataLayer.push(event);
			}
		},
		selectFilterEvent: (label) => {
			let value = "";
			/*
			if (clickedElement && clickedElement.classList.contains("component-checkbox")) {
				if (clickedElement.classList.contains("checked")) {
					// If checkbox is clicked while checked, user is unchecking the checkbox.
					value = "unchecked";
				} else {
					value = "checked";
				}
			}
			*/
			AnalyticsHelper.pushAnalyticsEvent({
				event: "GAEvent",
				eventCategory: "Budjettipaivat",
				eventAction: "Select Filter",
				eventLabel: label,
				eventNonInteraction: "false",
				eventValue: value
			});
		},
		openSearchAccordionEvent: (label) => {
			AnalyticsHelper.pushAnalyticsEvent({
				event: "GAEvent",
				eventCategory: "Budjettipaivat",
				eventAction: "Open Search Accordion",
				eventLabel: String(label).split(":")[0].trim(),
				eventNonInteraction: "false",
				eventValue: ""
			});
		},
		openSearchDropdown: (label) => {
			AnalyticsHelper.pushAnalyticsEvent({
				event: "GAEvent",
				eventCategory: "Budjettipaivat",
				eventAction: "Open Search Dropdown",
				eventLabel: label,
				eventNonInteraction: "false",
				eventValue: ""
			});
		},

		addSlotClickAnalytics: () => {

			for (const element of document.querySelectorAll(".slots-element")) {
				element.addEventListener("click", function (e) {
					const clickedSlot = Toolbox.closest(e.target, ".slot");
					if (clickedSlot) {
						const clickedSlotTitle = clickedSlot.querySelector("p");
						const clickedSlotAction = clickedSlot.querySelector(".link-arrow");
						const elementData = clickedSlotAction || clickedSlotTitle || false;
						AnalyticsHelper.pushAnalyticsEvent({
							event: "GAEvent",
							eventCategory: "Budjettipaivat",
							eventAction: "Banner Links",
							eventLabel: elementData ? String(elementData.textContent).trim() : "",
							eventNonInteraction: "false",
							eventValue: ""
						});
					}
				});

			}
		},

		clickCheckboxAnalytics: (clickedCheckbox) => {
			// Get Dropdown/accordion label.
			const getFilterDropdownLabel = (separator) => {

				if (separator === undefined) {
					separator = " - ";
				}

				const bdv = Toolbox.closest(clickedCheckbox, ".bar-dropdown-view");
				if (bdv) {
					const openViewFilter = Array.isArray(_state.viewOptionsWorkset.visibleFilters) ? _state.viewOptionsWorkset.visibleFilters.find(item => item.id === bdv.dataset.filter) : { name: bdv.dataset.filter };
					if (openViewFilter) {
						return String(openViewFilter.name ? openViewFilter.name + separator : "");
					} else {
						const componentDropdown = document.querySelector(".component-dropdown.component.dropdown-down");
						if (componentDropdown) {
							return componentDropdown.textContent.trim() + separator;
						} else {
							return "";
						}
					}
				} else {
					const featureAccordion = Toolbox.closest(clickedCheckbox, ".component-accordion");
					if (featureAccordion) {
						const featureAccordionLabel = featureAccordion.querySelector(".component-label");
						if (featureAccordionLabel) {
							return featureAccordionLabel.textContent.trim().split(":")[0] + separator;
						} else {
							return "";
						}

					} else {
						return "";
					}
				}
			};

			const optionGroup = Toolbox.closest(clickedCheckbox, ".option-group");
			if (optionGroup) {
				const optionHeader = optionGroup.querySelector(".option-header");
				AnalyticsHelper.selectFilterEvent(optionHeader ? getFilterDropdownLabel() + optionHeader.textContent.trim() + ": " + clickedCheckbox.textContent.trim() : clickedCheckbox.textContent.trim(), clickedCheckbox);
			} else {

				if (clickedCheckbox.dataset.checkboxGroup !== undefined) {
					const checkboxGroupNameLookup = {
						"marketingLabels": "Kampanjapäivät",
						"targetgroups": "Kohderyhmä"
					};
					const checkboxGroupName = checkboxGroupNameLookup[clickedCheckbox.dataset.checkboxGroup] ? checkboxGroupNameLookup[clickedCheckbox.dataset.checkboxGroup] : clickedCheckbox.dataset.checkboxGroup;
					AnalyticsHelper.selectFilterEvent(checkboxGroupName + ": " + clickedCheckbox.textContent.trim(), clickedCheckbox);
				} else {

					const bdv = Toolbox.closest(clickedCheckbox, ".bar-dropdown-view");
					if (bdv) {
						const openViewFilter = Array.isArray(_state.viewOptionsWorkset.visibleFilters) ? _state.viewOptionsWorkset.visibleFilters.find(item => item.id === bdv.dataset.filter) : { name: bdv.dataset.filter };
						if (openViewFilter) {
							AnalyticsHelper.selectFilterEvent(String(openViewFilter.name ? openViewFilter.name + ": " : "") + clickedCheckbox.textContent.trim(), clickedCheckbox);
						}
					} else {

						const featureAccordion = Toolbox.closest(clickedCheckbox, ".component-accordion");
						if (featureAccordion) {
							const featureAccordionLabel = featureAccordion.querySelector(".component-label").textContent.trim().split(":")[0];
							AnalyticsHelper.selectFilterEvent(featureAccordionLabel + ": " + clickedCheckbox.textContent.trim(), clickedCheckbox);
						} else {
							AnalyticsHelper.selectFilterEvent(clickedCheckbox.textContent.trim(), clickedCheckbox);
						}
					}

				}
			}
		}
	};

	return AnalyticsHelper;
})();

export default ListingAnalyticsHelper;